var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCat3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9443 19.5496C34.9443 19.5496 28.1413 13.6082 25.2251 23.7926C33.0009 28.885 34.9443 19.5496 34.9443 19.5496V19.5496Z",
    stroke: "#5671A6",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0001 32.6396L33.1353 29.3092",
    stroke: "#5671A6",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9493 35.97L30.0845 32.6396",
    stroke: "#5671A6",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.27634 28.7146C3.45696 26.9435 3.00635 25.0083 3.00635 22.9814L5.67601 2L13.7289 8.86246C15.825 8.08968 18.1304 7.66166 20.5498 7.66166H21.3126C23.732 7.66166 26.0374 8.08968 28.1335 8.86246L36.1864 2L38.8561 22.9814C38.8561 25.0083 38.4055 26.9435 37.5861 28.7146",
    stroke: "#5671A6",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91943 19.5496C6.91943 19.5496 13.7225 13.6082 16.6387 23.7926C8.86286 28.885 6.91943 19.5496 6.91943 19.5496V19.5496Z",
    stroke: "#5671A6",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.8623 32.6396L8.72714 29.3092",
    stroke: "#5671A6",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.91309 35.97L11.7779 32.6396",
    stroke: "#5671A6",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7775 22.6484C12.62 22.6484 13.303 22.052 13.303 21.3163C13.303 20.5805 12.62 19.9841 11.7775 19.9841C10.935 19.9841 10.252 20.5805 10.252 21.3163C10.252 22.052 10.935 22.6484 11.7775 22.6484Z",
    fill: "#5671A6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0841 22.6484C30.9266 22.6484 31.6096 22.052 31.6096 21.3163C31.6096 20.5805 30.9266 19.9841 30.0841 19.9841C29.2416 19.9841 28.5586 20.5805 28.5586 21.3163C28.5586 22.052 29.2416 22.6484 30.0841 22.6484Z",
    fill: "#5671A6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.731 27.0919H23.833",
    stroke: "#5671A6",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1553 29.0901C13.1553 29.0901 18.876 31.7544 20.7829 27.0919C22.6898 31.7544 28.7075 29.0582 28.7075 29.0582C28.7075 29.0582 26.732 31.8641 26.1497 32.4101C23.2033 35.173 19.2551 35.0064 16.1226 32.4849C15.4367 31.9327 13.1553 29.0901 13.1553 29.0901V29.0901Z",
    stroke: "#5671A6",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2881 36.0094C13.9756 37.4753 17.15 38.3219 20.5513 38.3219H21.3126C24.7138 38.3219 27.8897 37.4753 30.5758 36.0094",
    stroke: "#5671A6",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat3);
export default __webpack_public_path__ + "static/media/cat3.b58cfe4552a681f874917b5cadce0f90.svg";
export { ForwardRef as ReactComponent };